import gql from "graphql-tag"

export const locationVenueFragment = gql`
  fragment LocationVenue on Venue {
    id
    name
    description
    comments
    reservedBy
  }
`

export const locationMainFragment = gql`
  fragment LocationMain on Location {
    id
    userId
    name
    description
    comments
    isActive
    address
  }
`

export const locationQuery = gql`
  query location($id: ID!) {
    location(id: $id) {
      ...LocationMain
      venues {
        ...LocationVenue
      }
    }
  }
  ${locationMainFragment}
  ${locationVenueFragment}
`



// WEBPACK FOOTER //
// ./src/graphql/location.js